import { ExportAssetBarcodePage } from "../export_asset_barcode"
import { AssetMgtPageLoaderBase } from "./index"
/**
 * 頁面 /community/assetBarcode.aspx 執行此 Page loader
 */
export class AssetMgtExportAssetBarcodeLoader extends AssetMgtPageLoaderBase {

    private page = new ExportAssetBarcodePage()

    constructor() {
        super()
    }

    async load(): Promise<void> {
    }

    async loadOnDocumentReady(): Promise<void> {
        console.log("%s loadOnDocumentReady", this)
        this.page.fillBarcodes()
        this.page.showPrint()
    }

}
